import React from "react";

function Heading(props) {
  return (
    <h1 className="heading text-align-left padding-top-10-medium-device">
      {props.text}
    </h1>
  );
}

export default Heading;
